import { Alert, Space, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  secret: string
  onClose: () => void
}

export const OidcClientSecretAlert = ({ secret, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <Alert
      type="warning"
      showIcon
      closable={{ onClose }}
      title={t('oidc.client_secret', 'Client secret')}
      description={
        <Space vertical size={8}>
          <Typography.Text>
            {t(
              'oidc.store_secret_securely',
              'Store this secret securely. It will not be shown again.'
            )}
          </Typography.Text>
          <Typography.Paragraph copyable style={{ marginBottom: 0 }}>
            {secret}
          </Typography.Paragraph>
        </Space>
      }
    />
  )
}
